import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import { useFrozenClientTabBreadcrumbs } from "Helpers/useFrozenClientBreadcrumbs";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Client  } from "assets/SideBarIcons/customer.svg";
import ClientTabs from "./ClientTabs";
import { Box } from "@mui/material";
import ReviewsListing from "pages/Reviews/ReviewsListing";
export default function ClientReviews() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const params = useParams();
    const breadcrumbItems = useFrozenClientTabBreadcrumbs("reviews");
    return (<>
        <ComponentHeaderTwo
            showBtn={true}
            showSaveBtn={false}
            onClick={() => navigate('/clients')}
            onSubmit={() => {}}
            heading={t('customer') + ' (' + t('company') + ')'}
            icon={<Client height={28} width={28} />}
            btnText={"back"}
            btnType={"back"}
            showCreateBtn={false}
            breadcrumbItems={breadcrumbItems}
        />
        <Box className={`flex`}>
            <ClientTabs params={params} selectedIndex={7} />
            <Box className='mt-[10px] w-[100%]'>
                <ReviewsListing accountId={+(params as any)?.accountId} />
            </Box>
        </Box>
    </>)
}